import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveHotel,
  createHotel,
  deleteHotel,
  getAllActiveHotels,
  getAllHotels,
  getHotelByID,
  getHotelListWithRate,
  updateHotel,
  uploadHotelImage,
} from "./services/hotel.services";
import { IHotel, IHotelDetails, IHotelState, IPlannerHotelList } from "./hotelModel";

const initialState: IHotelState = {
  loading: false,
  error: "",
  HotelID: null,
  HotelList: [],
  PlannerHotelList: [],
  HotelDetail: {
    HotelName: "",
    HotelCode: "",
    HotelDisplayName: "",
    HotelAddress: "",
    LandMark: "",
    CountryID: null,
    StateID: null,
    CityID: null,
    LatitudeOfHotel: "",
    LongitudeOfHotel: "",
    MapURL: "",
    StarRating: null,
    PropertyType: "",
    Inclusions: "",
    Exclusions: "",
    HotelInformation: "",
    VendorID: null,
    IsActive: 1,
    HotelContacts: [],
  },
  deleteIndex: -1,
  rateDeleteIndex: -1,
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    clearHotelDetails: (state) => {
      state.HotelDetail = initialState.HotelDetail;
    },
    setHotelID: (state, action) => {
      state.HotelID = action.payload;
    },
    clearHotelID: (state) => {
      state.HotelID = initialState.HotelID;
    },
    setHotelContactDeleteIndex: (state, action) => {
      state.deleteIndex = action.payload;
    },
    setHotelRateDeleteIndex: (state, action) => {
      state.rateDeleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllHotels.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHotels.fulfilled,
      (state, action: PayloadAction<IHotel[]>) => {
        state.loading = false;
        state.HotelList = action.payload || [];
      }
    );
    builder.addCase(getAllHotels.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HotelList = [];
    });
    builder.addCase(getAllActiveHotels.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveHotels.fulfilled,
      (state, action: PayloadAction<IHotel[]>) => {
        state.loading = false;
        state.HotelList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveHotels.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HotelList = [];
    });
    builder.addCase(createHotel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createHotel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHotel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateHotel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateHotel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHotel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteHotel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHotel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHotel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getHotelByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getHotelByID.fulfilled,
      (state, action: PayloadAction<IHotelDetails>) => {
        state.loading = false;
        state.HotelDetail = action.payload;
      }
    );
    builder.addCase(getHotelByID.rejected, (state, action) => {
      state.loading = false;
      state.HotelDetail = initialState.HotelDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ActiveInactiveHotel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveHotel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveHotel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(uploadHotelImage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(uploadHotelImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(uploadHotelImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getHotelListWithRate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getHotelListWithRate.fulfilled,
      (state, action: PayloadAction<IPlannerHotelList[]>) => {
        state.loading = false;
        state.PlannerHotelList = action.payload || [];
      }
    );
    builder.addCase(getHotelListWithRate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PlannerHotelList = [];
    });
  },
});

export const {
  clearHotelDetails,
  setHotelID,
  clearHotelID,
  setHotelContactDeleteIndex,
  setHotelRateDeleteIndex,
} = hotelSlice.actions;
export default hotelSlice.reducer;
